import React from 'react';

// Main Breadcrumb container
interface BreadcrumbProps {
  children: React.ReactNode;
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ children, className = '' }) => {
  return (
    <nav className={`breadcrumb ${className}`} aria-label="breadcrumb">
      {children}
    </nav>
  );
};

// BreadcrumbList component
interface BreadcrumbListProps {
  children: React.ReactNode;
  className?: string;
}

export const BreadcrumbList: React.FC<BreadcrumbListProps> = ({ children, className = '' }) => {
  return (
    <ol className={`breadcrumb-list ${className}`}>
      {children}
    </ol>
  );
};

// BreadcrumbItem component
interface BreadcrumbItemProps {
  children: React.ReactNode;
  className?: string;
}

export const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({ children, className = '' }) => {
  return (
    <li className={`breadcrumb-item ${className}`}>
      {children}
    </li>
  );
};

// BreadcrumbLink component
interface BreadcrumbLinkProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
}

export const BreadcrumbLink: React.FC<BreadcrumbLinkProps> = ({ 
  children, 
  href = "#", 
  onClick, 
  className = '' 
}) => {
  return (
    <button
      type="button"
      className={`breadcrumb-link ${className}`}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) {
          onClick();
        }
      }}
    >
      {children}
    </button>
  );
};

// BreadcrumbPage component (current page)
interface BreadcrumbPageProps {
  children: React.ReactNode;
  className?: string;
}

export const BreadcrumbPage: React.FC<BreadcrumbPageProps> = ({ children, className = '' }) => {
  return (
    <span className={`breadcrumb-page ${className}`} aria-current="page">
      {children}
    </span>
  );
};

// BreadcrumbSeparator component
interface BreadcrumbSeparatorProps {
  className?: string;
}

export const BreadcrumbSeparator: React.FC<BreadcrumbSeparatorProps> = ({ className = '' }) => {
  return (
    <li className={`breadcrumb-separator ${className}`} aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="9,18 15,12 9,6" />
      </svg>
    </li>
  );
};
